import React, { useState, useEffect, useCallback, useMemo } from "react";
import { getDivingPoolsInfo, getLocationList } from "api/class";
import "components/reservation/PoolDetailInfoModal.scss";

const PoolDetailTable = ({  locationName }) => {
    const [poolInfo, setPoolInfo] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [locationCache, setLocationCache] = useState(null);

    // 위치 목록을 캐싱하여 재사용
    const fetchLocationList = useCallback(async () => {
        if (locationCache) {
            return locationCache;
        }

        try {
            const res = await getLocationList();
            setLocationCache(res);
            return res;
        } catch (error) {
            console.error("위치 목록을 불러오는데 실패했습니다:", error);
            throw error;
        }
    }, [locationCache]);

    // locationName으로부터 poolId를 메모이제이션
    const poolId = useMemo(() => {
        if (!locationCache || !locationName) return null;

        const targetLocation = locationCache.locations?.find(
            (location) => location.name === locationName
        );
        return targetLocation?.id || null;
    }, [locationCache, locationName]);

    // 풀 정보를 가져오는 함수
    const fetchPoolInfo = useCallback(async () => {
        if ( !locationName) return;

        setIsLoading(true);

        try {
            // 위치 목록이 없으면 먼저 가져오기
            if (!locationCache) {
                await fetchLocationList();
                return; // locationCache가 업데이트되면 useEffect가 다시 실행됨
            }

            // poolId가 있으면 풀 정보 가져오기
            if (poolId) {
                const data = await getDivingPoolsInfo(poolId);
                setPoolInfo(data);
            } else {
                throw new Error("Location not found");
            }
        } catch (error) {
            console.error("풀 정보를 불러오는데 실패했습니다:", error);
            setPoolInfo({});
        } finally {
            setIsLoading(false);
        }
    }, [ locationName, poolId, locationCache, fetchLocationList]);

    useEffect(() => {
        fetchPoolInfo();
    }, [fetchPoolInfo]);

    return (

        <div className="pool-detail-info-modal">
            <table className="pool-info-table">
                <tbody>
                <tr>
                        <th>잠수풀</th>
                        <td>{poolInfo.name || "-"}</td>
                    </tr>
                    <tr>
                        <th>주소</th>
                        <td>{poolInfo.address || "-"}</td>
                    </tr>
                    <tr>
                        <th>운영시간</th>
                        <td>
                            {poolInfo.operating_hours
                                ? `${poolInfo.operating_hours}`
                                : "-"}
                        </td>
                    </tr>
                    <tr>
                        <th>이용요금</th>
                        <td className="price">
                            {poolInfo.pricing || "-"}
                        </td>
                    </tr>
                    {poolInfo.facilities &&
                        poolInfo.facilities.length > 0 && (
                            <tr>
                                <th>편의시설</th>
                                <td>
                                    {poolInfo.facilities.join(", ")}
                                </td>
                            </tr>
                        )}
                    <tr>
                        <th>준비물</th>
                        <td>수건, 수영복, 수모, 샤워용품 등 (강습은 마스크, 스노클, 핀 무료 렌탈 가능)</td>
                    </tr>
                </tbody>
            </table>
        </div>

    );
};

export default PoolDetailTable;
